module.exports = __webpack_public_path__ + "6c4a0dbc/img/chevron-down-icon.5542f65c.svg";